import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderAutoscaler } from "../../advanced/providerAutoscaler";
import { ProviderNetworking } from "../../advanced/providerNetworking";
import { ProviderPreInstallScript } from "../../advanced/providerPreInstallScript";
import { NGInput } from "../../../../newcomponents/input/input";
import { NGInputListMst } from "../../../../newcomponents/inputList/inputListMst";
import { mk8sDryRun } from "../../../../mobxStores/dryRun/mk8s";
import { getDryRunErrorText } from "../../getDryRunErrorText";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderAzureAdvancedRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const a = mk8sDraft.provider_azure!;

  const tagsDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.azure.tags`,
    paths: a.tags.items.map((i) => `spec.provider.azure.tags.${i.firstValue}`),
  });

  return (
    //
    <>
      <div>
        <NGInputListMst
          data={a.tags}
          className="mb-8"
          label="Tags"
          firstLabel="Key"
          firstInput={(i) => {
            let invalid = false;
            if (!i.firstValue) {
              invalid = true;
            }
            if (i.firstValue && tagsDryRun.message.includes(`.${i.firstValue}`)) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.firstValue}
                onChange={(e) => i.setFirstValue(e.target.value)}
              />
            );
          }}
          secondLabel="Value"
          secondInput={(i) => {
            let invalid = false;
            if (i.secondValue && tagsDryRun.message.includes(`.${i.secondValue}`)) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.secondValue}
                onChange={(e) => i.setSecondValue(e.target.value)}
              />
            );
          }}
          invalid={tagsDryRun.severity === "error"}
          error={tagsDryRun.severity === "error" ? tagsDryRun.message : ""}
          warning={tagsDryRun.severity === "error" ? "" : tagsDryRun.message}
        />
        <div className="mb-4">
          <ProviderPreInstallScript provider="azure" preInstallScript={a.preInstallScript} />
        </div>
        <div className="mb-4">
          <ProviderNetworking clusterDraft={mk8sDraft} networking={a.networking} />
        </div>
        <div>
          <ProviderAutoscaler provider="azure" autoscaler={a.autoscaler} />
        </div>
      </div>
    </>
  );
};

export const ProviderAzureAdvanced = observer(ProviderAzureAdvancedRaw);
